import { render } from "./GameCategory.vue?vue&type=template&id=c9f200e4&scoped=true"
import script from "./GameCategory.vue?vue&type=script&lang=js"
export * from "./GameCategory.vue?vue&type=script&lang=js"

import "./GameCategory.vue?vue&type=style&index=0&id=c9f200e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f200e4"]])

export default __exports__